import styled from 'styled-components';

const StyledAnnotation = styled.div`
  color: #555;
  flex: 0 0 360px;
  font-size: 14px;
  padding-bottom: 20px;
  padding-right: 40px;
`;

const Title = styled.h2`
  && {
    color: #000;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
`; // sections have a heading:  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section

// type AnnotationProps = {
//   children?: React.ReactNode,
//   title?: string,
// };

export const Annotation = ({ children, title }) => (
  <StyledAnnotation data-test="annotation">
    {title && <Title>{title}</Title>}
    {children && children}
  </StyledAnnotation>
);
